require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/core-js/library/modules/es7.symbol.async-iterator.js
// module id = 858
// module chunks = 1